import { ApiClient } from '@oneethos/shared'
import config from './config'

export default new ApiClient(config.api.baseUrl)